"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.CollectionStatusModalCtrl = void 0;
const tslib_1 = require("tslib");
const core_api_1 = require("@ikegps/core-api");
const core_shared_1 = require("@ikegps/core-shared");
const mobx_1 = require("mobx");
const services_1 = require("../../services");
const page_state_1 = require("../../state/page.state");
const store_1 = require("../../store");
class CollectionStatusModalCtrl {
    constructor(collections) {
        this.pq = new core_shared_1.IkePromiseQueue(services_1.Logger, 10);
        this.settingStatus = false;
        this.collections = collections;
    }
    SetStatusCollections(status, allStatuses) {
        return tslib_1.__awaiter(this, void 0, void 0, function* () {
            if (this.settingStatus) {
                return;
            }
            this.setSettingStatus(true);
            const newCollectionUuids = [];
            for (const collection of this.collections) {
                const allStatusesForCollection = allStatuses.find((e) => e.collectionId === collection.objectId);
                if (allStatusesForCollection) {
                    if (status === null || allStatusesForCollection.statuses.indexOf(status) > -1) {
                        this.pq.add(() => tslib_1.__awaiter(this, void 0, void 0, function* () {
                            const uuid = yield this.updateCollectionStatus(collection, allStatusesForCollection, status);
                            newCollectionUuids.push(uuid);
                        }));
                    }
                }
            }
            yield this.pq.join();
            yield page_state_1.CurrentState.updateInspectedCollection();
            yield this.refresh(newCollectionUuids);
            this.setSettingStatus(false);
        });
    }
    updateCollectionStatus(collection, allStatusesForCollection, status) {
        return tslib_1.__awaiter(this, void 0, void 0, function* () {
            const rest = services_1.Services.Department.rest;
            const collectionJson = yield rest.Collection.getByRevision(collection.revision).fetch();
            collectionJson.data.data[allStatusesForCollection.statusFieldId] = status ? [status.split(' > ')] : [];
            const newCollection = yield rest.save(rest.Objects.Collection, collectionJson);
            return newCollection.uuid;
        });
    }
    refresh(collectionUuids) {
        return tslib_1.__awaiter(this, void 0, void 0, function* () {
            const collectionSummaries = yield Promise.all(collectionUuids.map((uuid) => store_1.AppStore.CollectionSummary.getFetchableByUuid(uuid).refetch()));
            return Promise.all([
                store_1.AppStore.Tag.refresh(),
                ...this.getTagIds(collectionSummaries).map((tagId) => store_1.AppStore.TagSummary.getFetchable(tagId).refetch()),
            ]);
        });
    }
    getTagIds(collectionSummaries) {
        const tags = {};
        for (const collectionSummary of collectionSummaries) {
            for (const tag of collectionSummary.tags) {
                if (!tags[tag] && !(0, core_api_1.isSystemTag)(tag)) {
                    tags[tag] = true;
                }
            }
        }
        return Object.keys(tags);
    }
    setSettingStatus(settingStatus) {
        this.settingStatus = settingStatus;
    }
    getActualStatuses() {
        const statuses = [];
        for (const summary of page_state_1.CurrentState.Tag.collections) {
            if (summary.status === 'undefined' || summary.status === '') {
                statuses.push('undefined');
            }
            else {
                statuses.push(summary.status);
            }
        }
        const result = statuses.reduce(function (allStatuses, status) {
            if (status in allStatuses) {
                allStatuses[status]++;
            }
            else {
                allStatuses[status] = 1;
            }
            return allStatuses;
        }, {});
        return result;
    }
}
exports.CollectionStatusModalCtrl = CollectionStatusModalCtrl;
tslib_1.__decorate([
    mobx_1.observable
], CollectionStatusModalCtrl.prototype, "settingStatus", void 0);
tslib_1.__decorate([
    mobx_1.action
], CollectionStatusModalCtrl.prototype, "setSettingStatus", null);
//# sourceMappingURL=collection.status.modal.ctrl.js.map